import styles from './FluIndices.module.scss'
import DefaultBreadcrumbs from '../../components/Breadcrumbs/DefaultBreadcrumbs'
const Header = ({ }) => {  
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_id={'NAT'}
            geo_type={'NAT'}
            dashboardType={'birthtrend'}
          />
        </div>
      </div>
    </>
  )
}
export default Header
